import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  bgContainer,
  bodyContainer,
  button,
  container,
  subContainer,
} from "./styles";
import DriverCardImg from "../../assets/imgs/img_driver_license.png";
import FingerPrintImg from "../../assets/imgs/img_fingerprint.png";
import InspectionImg from "../../assets/imgs/img_inspection.png";
import { colors } from "../../theme/colors";
import LoadingView from "../../components/LoadingView/LoadingView";
import { FingerprintsType, InspectionsType } from "../../types";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../../services/firebase";
import { isEmpty } from "../../utils";
import { addDoc, collection, onSnapshot } from "firebase/firestore";

const ServicePage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [inspections, setInspections] = useState<InspectionsType[]>([]);
  const [fingerPrints, setFingerPrints] = useState<FingerprintsType[]>([]);
  const [userId, setUserId] = useState<string>("");

  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setUserId(uid);
      } else {
        console.log("user is logged out");
      }
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(userId)) {
      getData();
    }
  }, [userId]);

  const getData = async () => {
    setIsLoading(true);
    onSnapshot(
      collection(db, "users/" + userId + "/fingerprints"),
      (snapshot) => {
        let tempFingerprints: FingerprintsType[] = [];
        let tempInspections: InspectionsType[] = [];
        snapshot.docs.map((doc) => {
          let one = doc.data() as FingerprintsType;
          tempFingerprints.push(one);
        });

        onSnapshot(
          collection(db, "users/" + userId + "/inspections"),
          (inspectionCollection) => {
            inspectionCollection.docs.map((inspection) => {
              let one = inspection.data() as InspectionsType;
              tempInspections.push(one);
            });
            setFingerPrints(tempFingerprints);
            setInspections(tempInspections);
            setIsLoading(false);
          }
        );
      }
    );
  };

  const handleDVI = async () => {
    if (inspections.length === 0 || inspections.length > 1) {
      navigate(`/inspection`);
    } else {
      navigate(`/inspection?id=${inspections[0].uid}`);
    }
  };

  const handleDCC = () => {
    if (fingerPrints.length === 0 || fingerPrints.length > 1) {
      navigate(`/criminal`);
    } else {
      navigate(`/criminal?id=${fingerPrints[0].uid}`);
    }
  };

  return (
    <Box sx={(theme) => bodyContainer(theme)}>
      <Box sx={(theme) => subContainer(theme)}>
        <Box sx={(theme) => bgContainer(theme)} />
        <Box sx={(theme) => container(theme)}>
          <Button
            variant="contained"
            sx={(theme) => button(theme)}
            onClick={() => handleDVI()}
          >
            Digital Vehicle Inspection
          </Button>
          <img
            src={InspectionImg}
            style={{
              marginTop: "30px",
              objectFit: "contain",
            }}
            alt="inspection"
          />
          <Button
            variant="contained"
            sx={(theme) => button(theme)}
            onClick={() => handleDCC()}
          >
            Digital Criminal Check
          </Button>
          <img
            src={FingerPrintImg}
            style={{
              marginTop: "30px",
              objectFit: "contain",
            }}
            alt="inspection"
          />
          
          {false && <Button
            variant="contained"
            sx={(theme) => button(theme)}
            onClick={() => navigate("/inspection")}
          >
            Digital PrDP Check
          </Button>
          }
          {false && <img
            src={DriverCardImg}
            style={{
              marginTop: "30px",
              objectFit: "contain",
            }}
            alt="inspection"
          />
          }
        </Box>
      </Box>
      {isLoading && <LoadingView />}
    </Box>
  );
};
export default ServicePage;
